import React from "react";
import "./header.css";

const Header = () => {
  return <span className="header">THE &nbsp;ENTERTAINMENT &nbsp;HUB</span>;
};

export default Header;
